import React, { useContext, useEffect, useState } from 'react';
import gql from 'graphql-tag';
import * as qs from 'query-string';
import { useLocation } from 'react-router-dom';
import { useQuery } from '@apollo/react-hooks';
import { Loading } from '../../../components/Loading';
import { growlErrors } from '../../../utils/NotificationUtil';
import { NotificationContext } from '../../../components/GrowlNotifications';
import BuySubscription from './BuySubscription';

const ACCOUNT_QUERY = gql`
  query accountQuery($accountId: ID!) {
    account(id: $accountId) {
      id
      displayName
      type
      subscriptionInformation {
        hasNoPreviousSubscription
        hasTrialPeriod
        freeTrialMonths
      }
    }
  }
`;

const DEFAULT_ACCOUNT_STATE = {
  id: null,
  displayName: null,
  type: null,
  subscriptionInformation: {
    hasNoPreviousSubscription: true,
    hasTrialPeriod: false,
    freeTrialMonths: null,
  },
};

const BuyOwnSubscription = () => {
  const [account, setAccount] = useState(DEFAULT_ACCOUNT_STATE);

  const { search } = useLocation();
  const { accountId } = qs.parse(search);
  const growl = useContext(NotificationContext);

  const { loading, error, data } = useQuery(ACCOUNT_QUERY, {
    variables: {
      accountId,
    },
  });

  const { account: accountFromQuery } = data;

  useEffect(() => {
    if (accountFromQuery) {
      setAccount(accountFromQuery);
    }
  }, [accountFromQuery]);

  if (loading) {
    return <Loading />;
  }

  if (error) {
    growlErrors(growl, error);
  }

  return <BuySubscription managingAccount={account} clientAccount={account} />;
};

export default BuyOwnSubscription;
